module.exports = __webpack_public_path__ + "build/assets/Aleo-Light-e0ffb6591423e34aebe1152429e475ad.woff";